module.exports = __webpack_public_path__ + "static/media/supergraphic.dfa3c1d9.png";